import Media1 from './todays-conveyancer.svg'
import Media2 from './todays-family-lawyer.svg'
import Media3 from './information-age.svg'
import Media4 from './global-legal-post.svg'
import Media5 from './b-new-logo.svg'
import Media6 from './challenge-works.svg'
import Media7 from './artificial-lawyer.svg'
import Media8 from './law-society-gazette.svg'
import Media9 from './leigh-day.svg'
import Media10 from './sra-logo.svg'
import Media11 from './gov-uk-logo.svg'
import Media12 from './legalfutures-logo.svg'
import Media13 from './startups-magazine.svg'

export const Section10Images = {
  Media1,
  Media2,
  Media3,
  Media4,
  Media5,
  Media6,
  Media7,
  Media8,
  Media9,
  Media10,
  Media11,
  Media12,
  Media13,
}
